import "./SupportHub.module.css";
import Header from "@/reusable_sections/Header";
import ConnectWithAiTech from "./sections/ConnectWithAiTech";
import OurHeadquarters from "./sections/OurHeadquarters";
import Footer from "@/reusable_sections/Footer";
export default function SupportHubPage() {
  return <div>
      <Header />
      <ConnectWithAiTech />
      <OurHeadquarters />
      <Footer />
    </div>;
}